import * as React from 'react';
import QuickCreatePage from 'screens/Tournaments/QuickCreatePage';

export default function QuickCreateTournament() {
  return (
    <>
      <QuickCreatePage />
    </>
  );
}
